import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const UserStatusIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6C10 4.89543 9.1046 4 8 4C6.8954 4 6 4.89543 6 6C6 7.1046 6.8954 8 8 8C9.1046 8 10 7.1046 10 6Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.666 12.666C14.666 11.5614 13.7706 10.666 12.666 10.666C11.5614 10.666 10.666 11.5614 10.666 12.666C10.666 13.7706 11.5614 14.666 12.666 14.666C13.7706 14.666 14.666 13.7706 14.666 12.666Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5691 9.14745C14.6337 8.77485 14.6673 8.39172 14.6673 8.00065C14.6673 4.31875 11.6825 1.33398 8.00065 1.33398C4.31875 1.33398 1.33398 4.31875 1.33398 8.00065C1.33398 11.6825 4.31875 14.6673 8.00065 14.6673C8.39172 14.6673 8.77485 14.6337 9.14745 14.5691"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66602 11.3333C4.66602 9.4924 6.1584 8 7.99935 8C9.04888 8 9.98508 8.48507 10.5961 9.2432"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
